import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ProgressItem {
  slug: string;
  value: string;
}

export interface ProgramGeneratorProgressState {
  programId: string | null;
  clientId: string | null;
  progress: Record<string, ProgressItem[]>;
}

export interface ProgramGeneratorProgressActions {
  setProgramId: (id: string | null) => void;
  setClientId: (id: string | null) => void;
  setProgress: (progress: Record<string, ProgressItem[]>) => void;
  updateStepProgress: (stepId: string, data: ProgressItem[]) => void;
  resetProgress: () => void;
}

export type ProgramGeneratorProgressStore = ProgramGeneratorProgressState &
  ProgramGeneratorProgressActions;

export const useProgramGeneratorProgressStore = create<ProgramGeneratorProgressStore>()(
  persist(
    (set) => ({
      programId: null,
      clientId: null,
      progress: {},
      setProgramId: (id) => set({ programId: id }),
      setClientId: (id) => set({ clientId: id }),
      setProgress: (progress) => set({ progress }),
      updateStepProgress: (stepId, data) =>
        set((state) => ({
          progress: {
            ...state.progress,
            [stepId]: data,
          },
        })),
      resetProgress: () => set({ programId: null, clientId: null, progress: {} }),
    }),
    {
      name: 'program-generator-storage',
    },
  ),
);
